<template>
    <ol class="availability-summary">
        <li
            v-for="day in days"
            :key="day.value"
            :class="slotClass(day.value)"
            @click="emitEvent({ name: 'select-day', payload: day.value })"
        >
            <div class="availability-summary__day-name">
                {{ day.name }}
            </div>

            <div class="availability-summary__time">
                <div v-for="(time, index) in timeSlots(day.value)" :key="index" class="availability-summary__time--item">
                    {{ minutesToTime(time.from) }}h &nbsp; {{ $t('common.microcopy.to') }} &nbsp; {{ minutesToTime(time.to) }}h
                </div>
            </div>
        </li>
        <li class="availability-summary__slot availability-summary__slot--user">
            <div>
                <common-user-avatar
                    class="availability-summary__slot--user-avatar"
                    size="large"
                    :user="user"
                ></common-user-avatar>

                <div v-if="user && user.firstName && user.lastName">{{ user.firstName }} {{ user.lastName }}</div>
            </div>
        </li>
    </ol>
</template>

<script>
    import DaysEnum from 'enums/days.enum'
    import availabilityTransformer from 'transformers/availabilityTransformer'

    export default {
        props: {
            user: { type: Object, default: undefined },
            slots: { type: Object, required: true },
            selectedDay: { type: String, required: true },
        },

        computed: {
            days() {
                return Object.values(DaysEnum[this.$i18n.locale])
            },
        },

        methods: {
            slotClass(day) {
                return {
                    'availability-summary__slot': true,
                    'availability-summary__slot--selected': day === this.selectedDay,
                }
            },

            timeSlots(day) {
                return this.slots[day]
            },

            minutesToTime(num) {
                return availabilityTransformer.minutesToTime(num)
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/availability/_availability-summary.scss';
</style>
